import { FunctionOpenInNewTab } from "radium-omnibus";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_ABOUT_US,
  TEXT_ACCORDING_TO_THE_LAUNDRY,
  TEXT_AFTER_PLACING_YOUR_ORDER,
  TEXT_ALL_LAUNDRY_PREMIUM,
  TEXT_ALL_OUR_PRICE_PRICING,
  TEXT_ALL_OUR_PRICE_PRICING_2,
  TEXT_AND_SEND_US,
  TEXT_AN_ORDER_NOW,
  TEXT_APART_FROM_THAT_GENERAL,
  TEXT_ARE_THERE_ANY_ADDITIONAL_COSTS,
  TEXT_ARE_THERE_ANY_ITEMS_OF_FABRIC,
  TEXT_ARE_THEY_HIDDEN_FEES,
  TEXT_AS_AN_EXPERIENCED,
  TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE,
  TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE_TH_1,
  TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE_TH_2,
  TEXT_AS_PART_BE_PICKED_UP,
  TEXT_AS_PART_OF_OUR_FIRST_ORDER,
  TEXT_AS_PART_VELOUR_LEATHERS_SHOES,
  TEXT_AS_SUSTAINABLE_AND_ENVIRONMENTALLY,
  TEXT_AT_THE_MOMENT_YOU_CANNOT_CHOOSE,
  TEXT_BEFORE_PLACING_ALL_PICKUP,
  TEXT_BEFORE_PLACING_ORDER_PICKUP,
  TEXT_BEFORE_PLACING_YOUR_ORDER_PICKUP,
  TEXT_BUT_WE_PLAN_TO_RESUME,
  TEXT_BUT_WE_PREPARING,
  TEXT_CAN_I_BRING_LAUNDRY_OR_SHOES,
  TEXT_CAN_I_PROVIDE_MY_OWN_DETERGENT,
  TEXT_CAN_I_REQUEST_PICKUP_AND_RETURN,
  TEXT_CAN_LEATHER_SHOES_OR_LEATHER,
  TEXT_CAN_PLATFORM_SHOES,
  TEXT_CAN_VELOUR_LEATHERS_SHOES,
  TEXT_CAN_YOU_REMOVE_STAINS,
  TEXT_CONTACTLESS_PICK_UP,
  TEXT_CONTACT_US,
  TEXT_CREATE,
  TEXT_DOES_MY_LAUNDRY_STORE_MY_CREDIT_CARD,
  TEXT_DO_I_HAVE_TO_BE_AT_HOME,
  TEXT_DO_I_NEED_FIRST_ORDER,
  TEXT_DO_I_NEED_SORT_MY_CLOTHES,
  TEXT_DO_I_NEED_TO_SIGN_UP,
  TEXT_DO_I_NEED_WEIGH_FIRST_ORDER,
  TEXT_DO_YOU_ACCEPT_CLOTHING,
  TEXT_DO_YOU_ACCEPT_SPECIAL_REQUESTS,
  TEXT_DO_YOU_ALSO_CLEAN_THE_SOLE_OF_SHOES,
  TEXT_DO_YOU_CLEAN_LEATHER,
  TEXT_DO_YOU_CLEAN_THE_INSOLES,
  TEXT_DO_YOU_CLEAN_WEDDINGSREESES,
  TEXT_DO_YOU_CLEAN_WHITE_SHOES,
  TEXT_DO_YOU_OFFER_A_HAND_WASHING,
  TEXT_DO_YOU_OFFER_DRY_CLEANING,
  TEXT_DO_YOU_PICKUP_AND_RETURN_DOORSTEP,
  TEXT_DO_YOU_PROVIDE_SERVICE_NEAR_ME,
  TEXT_DO_YOU_WASH_COMFORTERS,
  TEXT_DRIED_AT_AN_APPROPRIATE,
  TEXT_ECO_FRENDLY_PRODUCTS,
  TEXT_ENSURE_THAT_YOUR_ORDERS,
  TEXT_EVERY_MEMBER_OF_OUR_TEAM,
  TEXT_EX_IF_YOU_USE_HIGH_TEMP,
  TEXT_FIXED_PRICE_NO_SURPRIZE,
  TEXT_FOR_EXAMPLE_IF_YOU_CHOSEN,
  TEXT_FOR_EXAMPLE_OUR_ORGANIC,
  TEXT_FOR_YOUR_ORDER_YOU_CAN_USE,
  TEXT_GENERAL,
  TEXT_GOOD_TO_KNOW_PRICING,
  TEXT_HOW_CAN_I_KNOW_HOW_MUCH,
  TEXT_HOW_DO_I_CANCEL,
  TEXT_HOW_DO_I_MAKE_AN_ORDER,
  TEXT_HOW_DO_YOU_CLEAN_MY_CLOTHES,
  TEXT_HOW_DO_YOU_DRY,
  TEXT_HOW_DO_YOU_ENSURE_QUALITY,
  TEXT_IAM_ALLERGIC_TO_CERTAIN,
  TEXT_IF_YOU_ARE_NOT_HAPPY,
  TEXT_IF_YOU_WISH_TO_CANCEL,
  TEXT_INTERIOR_CLEANING,
  TEXT_INTIALLY_OUR_SYSTEM_WILL_AUTOMATICALLY,
  TEXT_IN_CASE_YOU_HAVE_ANYQESTION,
  TEXT_IN_THE_UNLIKELY_EVENT,
  TEXT_IS_THERE_ANY_EXTRA_CHARGE,
  TEXT_IS_THERE_ANY_MINIMUM_ORDER,
  TEXT_IS_THERE_IS_ANYTHING_ELSE_YOU,
  TEXT_IT_DEPENDS_ON_THE_MATERIAL,
  TEXT_I_PLACED_AN_ORDER,
  TEXT_KINDLY_MAKE_SURE,
  TEXT_LAUDRY_SERVICE_IN_DETAL,
  TEXT_MYLAUNDRY_PROVIDES_PROFESSIONAL,
  TEXT_MY_FIRST_ORDER,
  TEXT_MY_LAUNDRY_IS_FAIR_FIRST,
  TEXT_MY_LAUNDRY_PUTS_CUSTOMER,
  TEXT_NO_ALL_OUR_LAUNDRY_RE_FULLY_INCLUSIVE,
  TEXT_NO_AS_A_PROFESSIONAL_LAUNDRY_SERVICE,
  TEXT_NO_AT_THE_MOMENT,
  TEXT_NO_AT_THE_MOMENT_WE_ARE_ONLY_PICK_UP,
  TEXT_NO_AT_THE_MOMENT_WE_DO,
  TEXT_NO_CLEAN_LEATHER,
  TEXT_NO_DELIVERY_FEES_OR_HIDDEN_CHARGES,
  TEXT_NO_LEATHER_SHOES_AND_SNEAKERS,
  TEXT_NO_MINIMUM_ORDER,
  TEXT_NO_OFFER_DRY_CLEANING,
  TEXT_NO_TO_ENSURE,
  TEXT_NO_VELOUR_LEATHERS_SHOES,
  TEXT_NO_WASH_HAND,
  TEXT_NO_WE_WILL_SORT_THEM,
  TEXT_NO_YOU_DONT_NEED_TO_FIRST_ORDER,
  TEXT_OFFER_CONTACTLESS_PICKUP,
  TEXT_OK_KA,
  TEXT_ONE_PAIRS_EQUAL_ONE_PIECE,
  TEXT_OR,
  TEXT_OR_VIA_WHATSAPP_WECHAT,
  TEXT_OUR_PROFESSINAL_LANDRY_SERVICE,
  TEXT_OUR_SERVICE_HOURS_FOR_PICKUP_RETURN,
  TEXT_OUR_SERVICE_IN_THE_MORNING,
  TEXT_OUR_STANDARD_TURNAROUND_TIME_24_HOURS,
  TEXT_OUR_SYSTEMS_USE_API,
  TEXT_PICKUP_AND_RETURN_FAQ,
  TEXT_PLEASE_SELECT_THE_INTERIOR,
  TEXT_PRICES,
  TEXT_PRICING_AND_PAYMENT,
  TEXT_SELECT,
  TEXT_SHOE_CLEANING_FAQS,
  TEXT_TERM_AND_CONDITION,
  TEXT_THE_BRANDS_AND_MODELS,
  TEXT_THE_BRANDS_AND_MODELS_TH_1,
  TEXT_THE_BRANDS_AND_MODELS_TH_2,
  TEXT_THE_BRANDS_AND_MODELS_TH_MB_1,
  TEXT_THE_MOST_RECOMMENDED,
  TEXT_THE_SHOES_CLEANING_METHOD,
  TEXT_WE_ACCEPT_SPECIAL_REQUESTS,
  TEXT_WE_ALSO_OFFER_A_SAME_DAY,
  TEXT_WE_ALSO_RECCOMEND_SHOE,
  TEXT_WE_ALWAYS_BE_WASHED_SEPARATELY,
  TEXT_WE_ALWAYS_WASH_YOUR_LAUNDRY,
  TEXT_WE_BELIEVE_THAT_KEY,
  TEXT_WE_CAN_CLEAN_BOTH,
  TEXT_WE_CLEAN_ALL_FABRICS,
  TEXT_WE_CLEAN_SHOES,
  TEXT_WE_DEVIDE_SERVICE_INTO_TIME,
  TEXT_WE_DIVIDE_OUR_SERVICE,
  TEXT_WE_DO_NOT_CLEAN_MATTRESS,
  TEXT_WE_NOT_NOT_ALLOW_THIS_DUE_TO_HYGIENE,
  TEXT_WE_PROVIDE_LAUNDRY_SERVICE_IN_BKK_PTY,
  TEXT_WE_TRACK,
  TEXT_WE_WILL_SEND_YOU_AN_EMAIL,
  TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS,
  TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS_ADDIC_TH,
  TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS_ADDIC_TH_2,
  TEXT_WHAT_ARE_YOUR_SERVICE_HOURS,
  TEXT_WHAT_ARE_YOUR_SERVICE_HOURS_FOR_PICKUP,
  TEXT_WHAT_BAGS_SHOULD_I_USE,
  TEXT_WHAT_BRANDS_AND_MODELS,
  TEXT_WHAT_HAPPENS_IF_AM_NOT_HAPPY,
  TEXT_WHAT_HAPPENS_IN_THE_EVENT,
  TEXT_WHAT_IF_I_PUT_IN_MORE_LAUNDRY,
  TEXT_WHAT_IS_PRICING_STRATEGY,
  TEXT_WHAT_IS_YOUR_TURNAROUND_TIME,
  TEXT_WHAT_SERVICES_DOES_MYLAUNDRY_PROVIDE,
  TEXT_WHAT_TEMPERATURE,
  TEXT_WHAT_TYPES_AND_FABRICS,
  TEXT_WHAT_TYPES_OF_DEERGENTS,
  TEXT_WHAT_TYPES_OF_LAUNDRY_PRODUCTS,
  TEXT_WHEN_AND_HOW_DO_I_PAY,
  TEXT_WHEN_USE_OUR_PROFESSIONAL_SHOE,
  TEXT_WHEN_WILL_MY_ORDER_BE_RETURNED,
  TEXT_WHEN_WILL_MY_ORDER_FIRST_ORDER,
  TEXT_WHEN_YOU_CHOOSE_OUR_SPECIAL_STAIN_REMOVAL_ADD_ON,
  TEXT_WHEN_YOU_USE_OUR_PROFESIONAL_LAUNDRY_SERVICE,
  TEXT_WHERE_DO_I_CHOOSE_THE_DATE,
  TEXT_WHERE_DO_YOU_CLEAN_MY_CLOTHES,
  TEXT_WHO_CHOOSE_THE_CLENING_METHOD,
  TEXT_WHO_CLEANS_CLOTHES,
  TEXT_WHREN_WILL_MY_ORDER,
  TEXT_WHY_CHOOES_MY_LAUNDRY,
  TEXT_WHY_CHOOSE_MY_LAUNDRY,
  TEXT_WILLBE_I_ALERTED_WHEN_ORDER_IS_RETURNED,
  TEXT_WILL_MY_LAUNDRY_BE_WASHED,
  TEXT_WITH_NO_DYES_FRAGRANCES,
  TEXT_WITH_OUR_PREMIUM_SHOE,
  TEXT_YES_BUT_YOU_NEED_TO_SELECT_THE_CPMFORTER,
  TEXT_YES_CONTACTLESS_PICKUP,
  TEXT_YES_HOWEVER_MADE,
  TEXT_YES_ONE_PARIS_EQUAL_ONE_PIECE,
  TEXT_YES_REMOVING_STAINS,
  TEXT_YES_WE_CLEAN_SHOES,
  TEXT_YES_WE_HAVE_DEVELOPED,
  TEXT_YES_YOU_NEED_TO_SELECT_THE_COMFORTER,
  TEXT_YOR_ORDER_WILLBE_PICKED_UP_DURING,
  TEXT_YOUR_DESIRED_LAUNDRY_PRICING,
  TEXT_YOUR_ORDER_WILLBE_RETURNED,
  TEXT_YOUR_ORDER_WILLBE_RETURNED_1,
  TEXT_YOUR_ORDER_WILL_FIRST_ORDER,
  TEXT_YOUR_SERVICE_SHOE_FIRST_ORDER,
  TEXT_YOU_CAN_CHOOSE_OUR_SPECIAL,
  TEXT_YOU_CAN_CHOOSE_YOUR_PREFERRED,
  TEXT_YOU_CAN_REST_ASSURED,
  TEXT_YOU_JUST_NEED_TO_ENTER,
  TEXT_YOU_PAY_FOR_YOUR_ORDER_PRICING,
  TIME_STRING_ENG,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../../utils/useConstants";
import {
  FunctionChangeToBlueLink,
  FunctionChangeToBlueLinkNoBr,
  WhiteSpace,
} from "../../../utils/useFunction";
import { ICON_DOWN, ICON_UP } from "../../../utils/useIcons";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_1_SEMIBOLD_SM,
  STYLE_BOLD_BLUE,
  STYLE_DES_FAQ,
  STYLE_ICON_HOME_FAQ,
  STYLE_LINK_BLUE,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_PADDING_READING,
  STYLE_SIZE_FAQ,
} from "../../../utils/useStyle";
import FAQAboutTime from "./Faq.AboutTime";

const Whatbagsfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer   ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_BAGS_SHOULD_I_USE[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_FOR_YOUR_ORDER_YOU_CAN_USE[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const DoIneedfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_I_NEED_FIRST_ORDER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_AS_PART_OF_OUR_FIRST_ORDER[language]}
          </span>
          {isMobile ? (
            <React.Fragment>
              {language === "EN" ? (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              ) : (
                <div className="-ml-1">
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              )}
            </React.Fragment>
          ) : (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const DoIneedWeighfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_I_NEED_WEIGH_FIRST_ORDER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_YOU_DONT_NEED_TO_FIRST_ORDER[language]}
          </span>

          {/* {TEXT_OUR_PROFESSINAL_FIRST_ORDER[language]} */}
        </div>
      )}
    </div>
  );
};
const Whenwillmyorderfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHEN_WILL_MY_ORDER_FIRST_ORDER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {/* <span className="font-semibold">
            {TEXT_YOUR_ORDER_WILL_FIRST_ORDER[language]}
          </span> */}
          <FAQAboutTime />
        </div>
      )}
    </div>
  );
};
const IsPairofSockfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_ONE_PAIRS_EQUAL_ONE_PIECE[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_ONE_PARIS_EQUAL_ONE_PIECE[language]}
          </span>
          <span>
            {TEXT_MY_LAUNDRY_IS_FAIR_FIRST[language]}
            {isMobile ? (
              <React.Fragment>
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  {TEXT_CREATE[language]}
                </span>
                <span>{TEXT_AN_ORDER_NOW[language]}</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {location.pathname === "/FAQ" ||
                location.pathname === "/FAQ/TH" ? (
                  <span>
                    {" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`linkblue cursor-pointer`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    <span>{TEXT_AN_ORDER_NOW[language]}</span>
                  </span>
                ) : (
                  <div>
                    {" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`linkblue cursor-pointer`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    <span>{TEXT_AN_ORDER_NOW[language]}</span>
                  </div>
                )}
              </React.Fragment>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
const WhychooseMylaundryfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHY_CHOOSE_MY_LAUNDRY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {language === "TH" ? (
            <span>
              {" "}
              มายลอนดรี้
              ให้บริการซักอบรีดเสื้อผ้าและทำความสะอาดรองเท้าส่งถึงหน้าบ้านคุณ
              เราทุ่มเทอย่างเต็มที่และดูแลผ้าทุกชิ้นตามที่คุณมอบความไว้วางใจให้เรา
              และยังคำนึงถึงผลกระทบต่อสภาพแวดล้อม
              จึงใช้ผลิตภัณฑ์ที่เป็นมิตรต่อสิ่งแวดล้อม
              ซึ่งอ่อนโยนต่อผ้าและผิวหนังของผู้สวมใส่
              นอกจากนี้ร้านซักผ้ามายลอนดรี้ยังลดการใช้พลาสติกในการห่อผ้า
              เพื่อสร้างจิตสำนึกที่ดีต่อส่วนรวมในการลดพลาสติกให้น้อยลง
              ร้านซักผ้าและทำความสะอาดรองเท้า
              มายลอนดรี้ให้ความสำคัญกับการบริการลูกค้าเหนือสิ่งอื่นใด
              เราดีใจที่ทำให้ชีวิตของลูกค้าสะดวกและง่ายดายขึ้น ด้วย มายลอนดรี้
              คุณไม่ต้องกังวลในการหาร้านซักอบรีดเสื้อผ้าหรือทำความสะอาดรองเท้าในกรุงเทพอีกต่อไป
              อยากรู้ข้อมูลเพิ่มเติม เกี่ยวกับ
              <WhiteSpace>มายลอนดรี้</WhiteSpace>ไหม? เช็คดู
            </span>
          ) : (
            <span>
              {" "}
              My Laundry was established to offer convenient and affordable
              laundry, ironing and shoe cleaning services right to your
              doorstep. As part of our professional laundry service and shoe
              cleaning service, we put our full effort and care into every item
              you entrust to us, and we also consider the environment by using
              eco-friendly products that are gentle on the fabric and the
              wearer‘s skin. We are also committed to reducing unnecessary
              plastic use in our packaging to increase public awareness and
              participation in our efforts to reduce the use of plastic. My
              Laundry puts customer service first above all else and we are
              proud to provide a quality laundry service in Thailand that makes
              our customers’ lives easier. With My Laundry, you never need to
              worry about finding a place to wash, dry and iron your clothes or
              clean your shoes again. Want to know more about My Laundry? We are
              glad to tell you!
            </span>
          )}{" "}
          {language === "TH" ? (
            <span>
              {language === "EN" && `Check out`}{" "}
              <span
                onClick={() => navigate("/AboutUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_ABOUT_US[language]}
              </span>
              {language === "EN" && <span className="">.</span>}
            </span>
          ) : (
            <div>
              {language === "EN" && `Check out`}{" "}
              <span
                onClick={() => navigate("/AboutUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_ABOUT_US[language]}
              </span>
              {language === "EN" && <span className="">.</span>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
const IfthereisAnythingfirstorder = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={`${classNameTitle}`}>
          {TEXT_IS_THERE_IS_ANYTHING_ELSE_YOU[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)} -ml-1`}>
          <span
            onClick={() => navigate("/ContactUs")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CONTACT_US[language]}
          </span>
          {TEXT_OR[language]}
          <span
            onClick={() => navigate("/OurServices")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CREATE[language]}
          </span>
          {TEXT_AN_ORDER_NOW[language]}
        </div>
      )}
    </div>
  );
};

export const FirstOrder = ({
  classNameFont,
  classNameTitle,
  setOpen,
  open,
  superIndex,
}) => {
  const { language } = React.useContext(ContextLanguage);
  const location = useLocation();

  return (
    <div
      className={
        location.pathname === "/" || location.pathname === "/TH" ? "" : "mb-8"
      }
    >
      <div className={` ${classNameFont} ${STYLE_BOLD_BLUE}`}>
        {TEXT_MY_FIRST_ORDER[language]}
      </div>
      <Whatbagsfirstorder
        open={open}
        setOpen={setOpen}
        index={1}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <DoIneedfirstorder
        open={open}
        setOpen={setOpen}
        index={2}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <DoIneedWeighfirstorder
        open={open}
        setOpen={setOpen}
        index={3}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whenwillmyorderfirstorder
        open={open}
        setOpen={setOpen}
        index={4}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <IsPairofSockfirstorder
        open={open}
        setOpen={setOpen}
        index={5}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <WhychooseMylaundryfirstorder
        open={open}
        setOpen={setOpen}
        index={6}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <IfthereisAnythingfirstorder
        open={open}
        setOpen={setOpen}
        index={7}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
    </div>
  );
};

const IsThereAnyMunimumpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" ||
          location.pathname === "/Pricing" ||
          location.pathname === "/FAQ/TH" ||
          location.pathname === "/Pricing/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_IS_THERE_ANY_MINIMUM_ORDER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_MINIMUM_ORDER[language]}
          </span>
          {TEXT_ALL_OUR_PRICE_PRICING[language]}
          {TEXT_ALL_OUR_PRICE_PRICING_2[language]}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_DESIRED_LAUNDRY_PRICING[language]}
            <span
              onClick={() => navigate("/Pricing")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_PRICES[language]}
            </span>
            {TEXT_OK_KA[language]}
            {language === "EN" && <span className="-ml-1">.</span>}
          </span>
        </div>
      )}
    </div>
  );
};
const AreTheyHiddenpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_ARE_THEY_HIDDEN_FEES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_ALL_OUR_LAUNDRY_RE_FULLY_INCLUSIVE[language]}
          </span>
          {language === "TH" ? (
            <span>
              {" "}
              ร้านซักผ้าและทำความสะอาดรองเท้า มายลอนดรี้มี
              {isMobile ? <br /> : ""}นโยบายคือ ราคาแน่นอน ให้คุณแน่ใจ
              สิ่งนี้ทำให้เราแตกต่างจากร้านซักผ้ารายอื่นๆ
              ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล
              โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่
              ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ
              จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น!
              {isMobile ? <br /> : " "}
              มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ
              ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์
            </span>
          ) : (
            <span>
              {" "}
              Our professional laundry service policy is Fixed Price – No
              Surprises. This is what sets us apart from other laundry service
              providers who charge you by weight so you never know in advance
              how much you will really pay in the end. As part of our premium
              laundry service and shoe cleaning service in Bangkok, we are here
              to change the laundry service in Thailand for good! At My Laundry,
              you can be confident that you know the price you will pay for your
              laundry or shoes before we come to pick them up, as easy as
              ordering food or shopping online!
            </span>
          )}
          {/* {TEXT_OUR_PROFESSION_PRICING[language]} */}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_DESIRED_LAUNDRY_PRICING[language]}
            <span
              onClick={() => navigate("/Pricing")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_PRICES[language]}
            </span>
            {TEXT_OK_KA[language]}
            {language === "EN" && <span className="-ml-1">.</span>}
          </span>
        </div>
      )}
    </div>
  );
};
const HowCanIKnowpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_HOW_CAN_I_KNOW_HOW_MUCH[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_FIXED_PRICE_NO_SURPRIZE[language]}
            {language === "EN" && <span className="-ml-1">.</span>}
          </span>
          {/* {TEXT_THIS_IS_WHAT_SETS_UP_PRICING[language]} */}
          {language === "TH" ? (
            <span>
              {" "}
              สิ่งนี้ทำให้ร้านซักผ้ามายลอนดรี้แตกต่างจากร้านซักผ้า{" "}
              {!isMobile && <br />}รายอื่นๆ ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล
              โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่
              ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ
            </span>
          ) : (
            <span>
              {" "}
              This is what sets us apart from other laundry service providers
              who charge you by weight so you never know in advance how much you
              will really pay in the end. As part of our premium laundry service
              and shoe cleaning service in Bangkok, we are here to change the
              laundry service in Thailand for good! At My Laundry, you can be
              confident that you know the price you will pay for your laundry or
              shoes before we come to pick them up, as easy as ordering food or
              shopping online!
            </span>
          )}
          {language === "TH" && (
            <span>
              จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น!
              {isMobile ? <br /> : " "}
              มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ
              ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์
            </span>
          )}
          {/* {TEXT_THIS_IS_WHAT_SETS_UP_PRICING_2[language]} */}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_DESIRED_LAUNDRY_PRICING[language]}
            <span
              onClick={() => navigate("/Pricing")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_PRICES[language]}
            </span>
            {TEXT_OK_KA[language]}
            {language === "EN" && <span className="-ml-1">.</span>}
          </span>
        </div>
      )}
    </div>
  );
};
const WhatisPricingpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  const isFaq = location.pathname === "/FAQ" || location.pathname === "/FAQ/TH";
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        isFaq && "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_IS_PRICING_STRATEGY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_FIXED_PRICE_NO_SURPRIZE[language]}
            {language === "EN" && <span className="-ml-1">.</span>}
          </span>

          {/* {TEXT_THIS_IS_WHAT_SETS_UP_FROM_OTHER_LAUNDRY[language]} */}
          {language === "TH" ? (
            <span>
              {" "}
              สิ่งนี้ทำให้ร้านซักผ้ามายลอนดรี้แตกต่างจากร้านซักผ้า
              {!isMobile && !isFaq && <br />}รายอื่นๆ
              ที่เรียกเก็บเงินตามน้ำหนักเป็นกิโล
              โดยที่คุณไม่เคยรู้ราคาล่วงหน้าเลยว่าสุดท้ายแล้วคุณต้องจ่ายเท่าไหร่
              ร้านซักผ้าและทำความสะอาดรองเท้าของเราในกรุงเทพ
              จึงมาเพื่อเปลี่ยนแปลงรูปแบบของร้านรับซักผ้าเดลิเวอร์รี่ให้ดีขึ้น!
              {isMobile ? <br /> : " "}
              มายลอนดรี้ทำให้คุณมั่นใจได้ว่าคุณจะรู้ราคาที่ต้องชำระก่อนเราไปรับผ้าหรือรองเท้าของคุณ
              ทุกอย่างจึงง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์
            </span>
          ) : (
            <span>
              {" "}
              This is what sets us apart from other laundry service providers
              who charge you by weight so you never know in advance how much you
              will really pay in the end. As part of our premium laundry service
              and shoe cleaning service in Bangkok, we are here to change the
              laundry service in Thailand for good! At My Laundry, you can be
              confident that you know the price you will pay for your laundry or
              shoes before we come to pick them up, as easy as ordering food or
              shopping online!
            </span>
          )}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_DESIRED_LAUNDRY_PRICING[language]}
            <span
              onClick={() => navigate("/Pricing")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_PRICES[language]}
            </span>
            {TEXT_OK_KA[language]}
            {language === "EN" && <span className="-ml-1">.</span>}
          </span>
        </div>
      )}
    </div>
  );
};

const WhenAndHowpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;

  const TEXT_AS_OUR_STANDARD = {
    EN: "As our standard and recommendation, the default payment method for our laundry service and shoe cleaning service is Credit/Debit Card. However, we also offer you alternative payment methods which range from local bank transfers to QR Code Payments or Cash Advance (Cash Advance is only available for personal orders via our messenger channels - Please [Contact Us,/ContactUs]).",
    TH: ` ร้านซักผ้าและทำความสะอาดรองเท้า ${
      isMobile || (location?.pathname === "/FAQ" && !isMobile) ? "\n" : ""
    } มายลอนดรี้มีวิธีการชำระเงินแบบมาตรฐานคือบัตรเครดิต/เดบิต อย่างไรก็ตามเรามีตัวเลือกการชำระเงินอื่นๆ ตั้งแต่การโอนเงินผ่านธนาคาร ไปจนถึงการชำระเงินผ่าน QR Code หรือชำระเงินสดล่วงหน้า (การชำระเงินสดล่วงหน้าเป็นบริการผ่านช่องทางแอปแชทเท่านั้น กรุณา [ติดต่อเรา,/ContactUs]) เราขอแนะนำให้คุณเลือกวิธีการชำระเงินแบบไม่ใช้เงินสด เช่น บัตรเครดิต/เดบิต รวมถึงบริการชำระเงินผ่าน Wallet ได้แก่`,
  };
  const TEXT_AS_OUR_STANDARD_2 = {
    EN: "We are also offering Wallet Payments such as TrueMoney Wallet and Alipay! [Create,/OurServices] an order now!",
    TH: `TrueMoney Wallet และ Alipay ด้วย [สร้างออเดอร์,/OurServices] ตอนนี้เลย!`,
  };
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHEN_AND_HOW_DO_I_PAY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>

      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YOU_PAY_FOR_YOUR_ORDER_PRICING[language]}
          </span>
          {FunctionChangeToBlueLinkNoBr(
            TEXT_AS_OUR_STANDARD[language],
            navigate
          )}{" "}
          {language === "TH" ? (
            <React.Fragment>
              {isMobile ? (
                <React.Fragment>
                  TrueMoney Wallet และ Alipay ด้วย{" "}
                  <div>
                    {" "}
                    <span
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                      onClick={() => {
                        navigate("/OurServices");
                      }}
                    >
                      สร้างออเดอร์
                    </span>{" "}
                    ตอนนี้เลย!
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  TrueMoney Wallet และ Alipay ด้วย{" "}
                  <span>
                    {" "}
                    <span
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                      onClick={() => {
                        navigate("/OurServices");
                      }}
                    >
                      สร้างออเดอร์
                    </span>{" "}
                    ตอนนี้เลย!
                  </span>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {FunctionChangeToBlueLink(
                TEXT_AS_OUR_STANDARD_2[language],
                navigate
              )}{" "}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Whatifiputpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_IF_I_PUT_IN_MORE_LAUNDRY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {/* TEXT_SHOULD_YOU_FIND_PRICING */}
            {language === "TH" ? (
              <span>
                หากคุณพบว่ามีผ้าหรือรองเท้าที่ต้องซักมากกว่าที่จองแพ็กเกจไปแล้ว
                เราจะติดต่อคุณทางโทรศัพท์หรือผ่านทางแอปแชทต่างๆ
              </span>
            ) : (
              <span>
                Should you find you have more laundry or shoes to clean after
                you already booked a laundry service or shoe cleaning service,
                we will contact you by phone or via messaging apps.{" "}
              </span>
            )}
          </span>
          {/* {TEXT_GOOD_TO_KNOW_PRICING[language]} */}
          {/* {language === "TH" ? (
            <span className="">
              {" "}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CREATE[language]}
              </span>{" "}
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          ) : (
            <React.Fragment>
              {location.pathname === "/FAQ" ? (
                <span>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              ) : (
                <div>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              )}
            </React.Fragment>
          )} */}
        </div>
      )}
    </div>
  );
};
const DoesMyLaundrycreditcardpricing = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DOES_MY_LAUNDRY_STORE_MY_CREDIT_CARD[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_AS_A_PROFESSIONAL_LAUNDRY_SERVICE[language]}
          </span>
          <span
            onClick={() => navigate("/OurServices")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CREATE[language]}
          </span>
          {TEXT_AN_ORDER_NOW[language]}
        </div>
      )}
    </div>
  );
};

export const Pricing = ({ classNameTitle, open, setOpen, superIndex }) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);

  const location = useLocation();

  return (
    <div className=" mb-8">
      <div
        className={`${STYLE_SIZE_FAQ(
          language
        )}${STYLE_BOLD_BLUE} 1 -mb-4 md:mb-0`}
      >
        {TEXT_PRICING_AND_PAYMENT[language]}
      </div>
      <IsThereAnyMunimumpricing
        open={open}
        setOpen={setOpen}
        index={1}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <AreTheyHiddenpricing
        open={open}
        setOpen={setOpen}
        index={2}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <HowCanIKnowpricing
        open={open}
        setOpen={setOpen}
        index={3}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <WhatisPricingpricing
        open={open}
        setOpen={setOpen}
        index={4}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <WhenAndHowpricing
        open={open}
        setOpen={setOpen}
        index={5}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whatifiputpricing
        open={open}
        setOpen={setOpen}
        index={6}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <DoesMyLaundrycreditcardpricing
        open={open}
        setOpen={setOpen}
        index={7}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
    </div>
  );
};

const DoIhavetobepickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_I_HAVE_TO_BE_AT_HOME[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_CONTACTLESS_PICK_UP[language]}
          </span>
          {TEXT_BEFORE_PLACING_ORDER_PICKUP[language]}

          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const OfferContactlesspickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_OFFER_CONTACTLESS_PICKUP[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_CONTACTLESS_PICKUP[language]}
          </span>
          {TEXT_BEFORE_PLACING_YOUR_ORDER_PICKUP[language]}

          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Doyoupickuppickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_PICKUP_AND_RETURN_DOORSTEP[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_ENSURE_THAT_YOUR_ORDERS[language]}
          </span>
          {TEXT_BEFORE_PLACING_ALL_PICKUP[language]}

          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Whatareyourservicepickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_ARE_YOUR_SERVICE_HOURS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {/* <span className="font-semibold">
            {TEXT_OUR_SERVICE_HOURS_FOR_PICKUP_RETURN[language]}
          </span> */}
          <FAQAboutTime />
        </div>
      )}
    </div>
  );
};
const Wheredoichoosethedatepickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHERE_DO_I_CHOOSE_THE_DATE[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YOU_CAN_CHOOSE_YOUR_PREFERRED[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Whenwillmyorderpickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHREN_WILL_MY_ORDER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {/* <span className="font-semibold">
            {TEXT_YOR_ORDER_WILLBE_PICKED_UP_DURING[language]}
          </span> */}
          <FAQAboutTime />
        </div>
      )}
    </div>
  );
};
const Whenwillmyorderbereturnedpickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHEN_WILL_MY_ORDER_BE_RETURNED[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {/* <span className="font-semibold">
            {TEXT_YOUR_ORDER_WILLBE_RETURNED[language]}
          </span> */}
          <FAQAboutTime />
        </div>
      )}
    </div>
  );
};
const Whenwillalertpickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {/* {TEXT_WILLBE_I_ALERTED_WHEN_ORDER_IS_RETURNED[language]} */}
          {language === "TH" ? (
            <span>
              ฉันจะได้รับการแจ้งเตือนเวลาส่งคืน<WhiteSpace>ออเดอร์</WhiteSpace>
              ไหม?
            </span>
          ) : (
            "Will I be I alerted when my order is returned? "
          )}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_WILL_SEND_YOU_AN_EMAIL[language]}
          </span>
          {TEXT_WHEN_YOU_USE_OUR_PROFESIONAL_LAUNDRY_SERVICE[language]}

          {isMobile && language === "TH" ? (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          ) : (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
const CanIRequestpickuppickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_I_REQUEST_PICKUP_AND_RETURN[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_AT_THE_MOMENT_WE_ARE_ONLY_PICK_UP[language]}
          </span>

          {language === "EN" && (
            <span>
              {TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE[language]}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
          {language === "TH" && (
            <span>
              {TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE_TH_1[language]}
              <div>
                {TEXT_AS_A_PROFESSIONAL_LAUNDRY_SERVICE_SHOE_TH_2[language]}
              </div>
              <div className="-ml-1">
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW[language]}
              </div>
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const IsThereanyextrapickup = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_IS_THERE_ANY_EXTRA_CHARGE[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_DELIVERY_FEES_OR_HIDDEN_CHARGES[language]}
          </span>

          <span
            style={
              {
                // white-space:nowrap;
              }
            }
          >
            {" "}
            <span
              style={{
                whiteSpace: "nowrap",
              }}
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_CREATE[language]}
            </span>{" "}
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};

const Pickup = ({ classNameTitle, open, setOpen, superIndex }) => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();

  return (
    <div className="mb-8">
      <div className={`${STYLE_SIZE_FAQ(language)} ${STYLE_BOLD_BLUE} 2`}>
        {TEXT_PICKUP_AND_RETURN_FAQ[language]}
      </div>
      <DoIhavetobepickup
        open={open}
        setOpen={setOpen}
        index={1}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <OfferContactlesspickup
        open={open}
        setOpen={setOpen}
        index={2}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyoupickuppickup
        open={open}
        setOpen={setOpen}
        index={3}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whatareyourservicepickup
        open={open}
        setOpen={setOpen}
        index={4}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Wheredoichoosethedatepickup
        open={open}
        setOpen={setOpen}
        index={5}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whenwillmyorderpickup
        open={open}
        setOpen={setOpen}
        index={6}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whenwillmyorderbereturnedpickup
        open={open}
        setOpen={setOpen}
        index={7}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whenwillalertpickup
        open={open}
        setOpen={setOpen}
        index={8}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <CanIRequestpickuppickup
        open={open}
        setOpen={setOpen}
        index={9}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <IsThereanyextrapickup
        open={open}
        setOpen={setOpen}
        index={10}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
    </div>
  );
};

const Whatservicesdoesgeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_SERVICES_DOES_MYLAUNDRY_PROVIDE[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {TEXT_MYLAUNDRY_PROVIDES_PROFESSIONAL[language]}
          {isMobile && language === "TH" ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          ) : (
            <React.Fragment>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};

const HowdoImakeordergeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border   ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_HOW_DO_I_MAKE_AN_ORDER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_THE_MOST_RECOMMENDED[language]}
          </span>
          {TEXT_APART_FROM_THAT_GENERAL[language]}{" "}
          <span
            onClick={() =>
              FunctionOpenInNewTab(
                "https://page.line.me/?accountId=mylaundrythai"
              )
            }
            className={`${STYLE_LINK_BLUE_NO_MX}`}
          >
            @mylaundrythai
          </span>{" "}
          {TEXT_OR_VIA_WHATSAPP_WECHAT[language]}
          <span>
            {" "}
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_CREATE[language]}
            </span>{" "}
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};

const Whatisyourturnaroundgeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_IS_YOUR_TURNAROUND_TIME[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {/* <span className="font-semibold">
            {TEXT_OUR_STANDARD_TURNAROUND_TIME_24_HOURS[language]}
          </span> */}
          <FAQAboutTime />
          {/* {TEXT_FOR_EXAMPLE_IF_YOU_CHOSEN[language]} */}
          {/* <span className="font-semibold">
            {TEXT_WE_ALSO_OFFER_A_SAME_DAY[language]}
          </span>
          {isMobile ? (
            <span className="">
              {" "}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CREATE[language]}
              </span>{" "}
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          ) : (
            <span>
              {" "}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CREATE[language]}
              </span>{" "}
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )} */}
        </div>
      )}
    </div>
  );
};
const Doyouprovidegeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_PROVIDE_SERVICE_NEAR_ME[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_PROVIDE_LAUNDRY_SERVICE_IN_BKK_PTY[language]}
          </span>
          {TEXT_OUR_SYSTEMS_USE_API[language]}

          {isMobile && language === "TH" ? (
            <span className="">
              {" "}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CREATE[language]}
              </span>{" "}
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          ) : (
            <React.Fragment>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const IPlacegeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>{TEXT_I_PLACED_AN_ORDER[language]}</div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_AFTER_PLACING_YOUR_ORDER[language]}
          </span>
          {TEXT_YOU_CAN_REST_ASSURED[language]}
          {language === "TH" ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {TEXT_OR[language]}
              <span>
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE} `}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW[language]}
              </span>
            </div>
          ) : (
            <React.Fragment>
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {TEXT_OR[language]}
              <span>
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE} `}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW[language]}
              </span>
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Howdoyouensuregeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_HOW_DO_YOU_ENSURE_QUALITY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_BELIEVE_THAT_KEY[language]}
          </span>
          {TEXT_EVERY_MEMBER_OF_OUR_TEAM[language]}
          <span
            onClick={() => navigate("/ContactUs")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CONTACT_US[language]}
          </span>
          {TEXT_OR[language]}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {isMobile && language === "EN" ? (
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            ) : (
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
const Whatareyourservicegeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_ARE_YOUR_SERVICE_HOURS_FOR_PICKUP[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {/* <span className="font-semibold">
            {TEXT_OUR_SERVICE_IN_THE_MORNING[language]}
          </span> */}
          <FAQAboutTime />
        </div>
      )}
    </div>
  );
};
const DoIneedtoSignupgeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_I_NEED_TO_SIGN_UP[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_HOWEVER_MADE[language]}
          </span>
          {TEXT_YOU_JUST_NEED_TO_ENTER[language]}
          {isMobile ? (
            <React.Fragment>
              {language === "TH" ? (
                <div>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>{" "}
                </div>
              ) : (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>
                </span>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <div className="">
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              ) : (
                <span className="">
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const CanIBringgeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_I_BRING_LAUNDRY_OR_SHOES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">{TEXT_NO_TO_ENSURE[language]}</span>
          {TEXT_ALL_LAUNDRY_PREMIUM[language]}

          {language === "TH" ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          ) : (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const HowDoICancelgeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>{TEXT_HOW_DO_I_CANCEL[language]}</div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_IF_YOU_WISH_TO_CANCEL[language]}
          </span>{" "}
          <span
            onClick={() => navigate("/ContactUs")}
            className={STYLE_LINK_BLUE_NO_MX}
          >
            {TEXT_CONTACT_US[language]}
          </span>
          {language === "EN" && <span className="">.</span>}
        </div>
      )}
    </div>
  );
};
const Doyouacceptgeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_ACCEPT_CLOTHING[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_AT_THE_MOMENT_WE_DO[language]}
          </span>
          {TEXT_IN_CASE_YOU_HAVE_ANYQESTION[language]}
          <span
            onClick={() => navigate("/ContactUs")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CONTACT_US[language]}
          </span>
          {TEXT_OR[language]}
          <span
            onClick={() => navigate("/OurServices")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CREATE[language]}
          </span>
          {TEXT_AN_ORDER_NOW[language]}
        </div>
      )}
    </div>
  );
};
const Whychoosegeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHY_CHOOES_MY_LAUNDRY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {language === "TH" ? (
            <span>
              มายลอนดรี้
              ให้บริการซักอบรีดเสื้อผ้าและทำความสะอาดรองเท้าส่งถึงหน้าบ้านคุณ
              เราทุ่มเทอย่างเต็มที่และดูแลผ้าทุกชิ้นตามที่คุณมอบความไว้วางใจให้เรา
              และยังคำนึงถึงผลกระทบต่อสภาพแวดล้อม
              จึงใช้ผลิตภัณฑ์ที่เป็นมิตรต่อสิ่งแวดล้อม
              ซึ่งอ่อนโยนต่อผ้าและผิวหนังของผู้สวมใส่
              นอกจากนี้ร้านซักผ้ามายลอนดรี้ยังลดการใช้พลาสติกในการห่อผ้า
              เพื่อสร้างจิตสำนึกที่ดีต่อส่วนรวมในการลดพลาสติกให้น้อยลง
              ร้านซักผ้าและทำความสะอาดรองเท้า
              มายลอนดรี้ให้ความสำคัญกับการบริการลูกค้าเหนือสิ่งอื่นใด
              เราดีใจที่ทำให้ชีวิตของลูกค้าสะดวกและง่ายดายขึ้น ด้วยมายลอนดรี้
              คุณไม่ต้องกังวลในการหาร้านซักอบรีดเสื้อผ้าหรือทำความสะอาดรองเท้าในกรุงเทพอีกต่อไป
              อยากรู้ข้อมูลเพิ่มเติมเกี่ยวกับ{isMobile ? <br /> : ""}
              มายลอนดรี้ไหม? เช็คดู
            </span>
          ) : (
            <span>
              My Laundry was established to offer convenient and affordable
              laundry, ironing and shoe cleaning services right to your
              doorstep. As part of our professional laundry service and shoe
              cleaning service, we put our full effort and care into every item
              you entrust to us, and we also consider the environment by using
              eco-friendly products that are gentle on the fabric and the
              wearer‘s skin. We are also committed to reducing unnecessary
              plastic use in our packaging to increase public awareness and
              participation in our efforts to reduce the use of plastic. My
              Laundry puts customer service first above all else and we are
              proud to provide a quality laundry service in Thailand that makes
              our customers’ lives easier. With My Laundry, you never need to
              worry about finding a place to wash, dry and iron your clothes or
              clean your shoes again. Want to know more about My Laundry? We are
              glad to tell you!
            </span>
          )}
          {/* {TEXT_MY_LAUNDRY_WAS_ESTABLISHED[language]} */}{" "}
          {language === "TH" ? (
            <span>
              <span
                onClick={() => navigate("/AboutUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_ABOUT_US[language]}
              </span>
            </span>
          ) : (
            <div>
              Check out{" "}
              <span
                onClick={() => navigate("/AboutUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_ABOUT_US[language]}
              </span>
              <span className="">.</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
const IsThereisAnythinggeneral = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_IS_THERE_IS_ANYTHING_ELSE_YOU[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {" "}
          <span
            onClick={() => navigate("/ContactUs")}
            className={`${STYLE_LINK_BLUE_NO_MX}`}
          >
            {TEXT_CONTACT_US[language]}
          </span>{" "}
          {TEXT_OR[language]}
          <span
            onClick={() => navigate("/OurServices")}
            className={`${STYLE_LINK_BLUE}`}
          >
            {TEXT_CREATE[language]}
          </span>
          {TEXT_AN_ORDER_NOW[language]}
        </div>
      )}
    </div>
  );
};

const General = ({ classNameTitle, open, setOpen, superIndex }) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className="mb-8">
      <div
        className={`${STYLE_SIZE_FAQ(
          language
        )} ${STYLE_BOLD_BLUE} 3 -mb-4 md:mb-0`}
      >
        {TEXT_GENERAL[language]}
      </div>
      <HowdoImakeordergeneral
        open={open}
        setOpen={setOpen}
        index={1}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Whatservicesdoesgeneral
        open={open}
        setOpen={setOpen}
        index={2}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Whatisyourturnaroundgeneral
        open={open}
        setOpen={setOpen}
        index={3}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Doyouprovidegeneral
        open={open}
        setOpen={setOpen}
        index={4}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <IPlacegeneral
        open={open}
        setOpen={setOpen}
        index={5}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Howdoyouensuregeneral
        open={open}
        setOpen={setOpen}
        index={6}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Whatareyourservicegeneral
        open={open}
        setOpen={setOpen}
        index={7}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <DoIneedtoSignupgeneral
        open={open}
        setOpen={setOpen}
        index={8}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <CanIBringgeneral
        open={open}
        setOpen={setOpen}
        index={9}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <HowDoICancelgeneral
        open={open}
        setOpen={setOpen}
        index={10}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Doyouacceptgeneral
        open={open}
        setOpen={setOpen}
        index={11}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <Whychoosegeneral
        open={open}
        setOpen={setOpen}
        index={12}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
      <IsThereisAnythinggeneral
        open={open}
        setOpen={setOpen}
        index={13}
        superIndex={superIndex}
        classNameTitle={classNameTitle}
      />
    </div>
  );
};

const DoINeedSortcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_I_NEED_SORT_MY_CLOTHES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_WE_WILL_SORT_THEM[language]}
          </span>
          {isMobile ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          ) : (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const WillMyLaundrybewashedcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WILL_MY_LAUNDRY_BE_WASHED[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_ALWAYS_BE_WASHED_SEPARATELY[language]}
          </span>

          {language === "EN" ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          ) : (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const WhatTemperaturecleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>{TEXT_WHAT_TEMPERATURE[language]}</div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_ALWAYS_WASH_YOUR_LAUNDRY[language]}
          </span>
          {TEXT_ACCORDING_TO_THE_LAUNDRY[language]}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Howdoyoudrycleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>{TEXT_HOW_DO_YOU_DRY[language]}</div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_DRIED_AT_AN_APPROPRIATE[language]}
          </span>
          {TEXT_YOU_CAN_CHOOSE_OUR_SPECIAL[language]}
          {!isMobile && language === "TH" ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          ) : (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const Whattypesoflaundrycleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_TYPES_OF_LAUNDRY_PRODUCTS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_ECO_FRENDLY_PRODUCTS[language]}
          </span>

          {isMobile ? (
            <React.Fragment>
              {language === "EN" ? (
                <span>
                  {TEXT_FOR_EXAMPLE_OUR_ORGANIC[language]}
                  <span
                    onClick={() => navigate("/ContactUs")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CONTACT_US[language]}
                  </span>
                  {TEXT_OR[language]}
                  <span className="">
                    {" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    <span> {TEXT_AN_ORDER_NOW[language]}</span>
                  </span>
                </span>
              ) : (
                <span>
                  {TEXT_FOR_EXAMPLE_OUR_ORGANIC[language]}

                  <span>
                    {language === "TH" && " หากมีคำถามอื่นๆ"}{" "}
                    <span
                      onClick={() => navigate("/ContactUs")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CONTACT_US[language]}
                    </span>{" "}
                    {TEXT_OR[language]}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    <span>{TEXT_AN_ORDER_NOW[language]}</span>
                  </span>
                </span>
              )}
            </React.Fragment>
          ) : (
            <span>
              {TEXT_FOR_EXAMPLE_OUR_ORGANIC[language]}
              {language === "TH" && " หากมีคำถามอื่นๆ"}
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {TEXT_OR[language]}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {language === "EN" ? (
                <div>{TEXT_AN_ORDER_NOW[language]}</div>
              ) : (
                <span>{TEXT_AN_ORDER_NOW[language]}</span>
              )}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const IamAllergiccleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_IAM_ALLERGIC_TO_CERTAIN[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_AS_SUSTAINABLE_AND_ENVIRONMENTALLY[language]}
          </span>
          {TEXT_WITH_NO_DYES_FRAGRANCES[language]}
          {isMobile ? (
            <span>
              {" "}
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>{" "}
              {TEXT_OR[language]}{" "}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CREATE[language]}
              </span>{" "}
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            </span>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <span className="">
                  {" "}
                  <span
                    onClick={() => navigate("/ContactUs")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CONTACT_US[language]}
                  </span>{" "}
                  {TEXT_OR[language]}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              ) : (
                <span>
                  <span
                    onClick={() => navigate("/ContactUs")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CONTACT_US[language]}
                  </span>
                  {TEXT_OR[language]}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const WhattypesofDetergentscleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_TYPES_OF_DEERGENTS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_AT_THE_MOMENT_YOU_CANNOT_CHOOSE[language]}
          </span>
          {/* {TEXT_HOW_EVER_WE_OFFER_ORGANIC[language]} */}
          {language === "TH" ? (
            <span>
              {" "}
              อย่างไรก็ตามเราขอแนะนำให้คุณเลือกเพิ่มเติมผลิตภัณฑ์ซักผ้าออร์แกนิคหรือ
              {isMobile && <br />}ผลิตภัณฑ์ซักผ้าสำหรับเด็ก
              โดยน้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิคของเราประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น
              ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ
              อีกทั้งผลิตภัณฑ์ซักผ้าและปรับผ้านุ่มสำหรับเด็กยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า
              ป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี
              และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้
              หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคหรือซักผ้าสำหรับเด็ก
              กรุณาเลือกเพิ่มเติมฟรี ไม่ใช้น้ำยาปรับผ้านุ่ม
              นอกจากนี้เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคและผลิตภัณฑ์สำหรับเด็กทั้งในและต่างประเทศด้วย
              กรุณาแจ้งความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีด
              <span
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                มายลอนดรี้
              </span>
              หากมีคำถามอื่นๆ
            </span>
          ) : (
            <span>
              {" "}
              However, we offer Organic Wash or Baby Wash Add-Ons. Free from
              dyes, fragrances or preservatives, our Organic Wash detergents and
              softeners contain only plant-based, naturally-sourced and mineral
              ingredients. Specially designed for sensitive skin requirements
              and dermatologically tested to prevent allergic reactions, our
              Baby Wash detergents and softeners are hypoallergenic and free of
              dyes but still strong in removing all the stains your baby loves
              to make. If you wish us to use only detergent with no softener in
              your Organic or Baby Wash, please select the free of charge No
              Softener Add-On. PS: We use a variety of locally and
              internationally sourced Organic and Baby Wash products in our
              laundry service. Use the Special Request box before placing your
              laundry service order to tell us your preferences and we will
              fulfil your request whenever possible. In case you have any
              questions, you can always
            </span>
          )}
          <span>
            {" "}
            <span
              onClick={() => navigate("/ContactUs")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_CONTACT_US[language]}
            </span>{" "}
            {TEXT_OR[language]}
            {isMobile ? (
              <React.Fragment>
                {language === "TH" ? (
                  <span className="">
                    {" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                ) : (
                  <span>
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    <div> {TEXT_AN_ORDER_NOW[language]}</div>
                  </span>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {language === "EN" ? (
                  <span>
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                ) : (
                  <div className="-ml-1">
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </div>
                )}
              </React.Fragment>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
const CanIprovidecleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_I_PROVIDE_MY_OWN_DETERGENT[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_NOT_NOT_ALLOW_THIS_DUE_TO_HYGIENE[language]}
          </span>

          <div className="-ml-1">
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </div>
        </div>
      )}
    </div>
  );
};
const Canyouremovestainscleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_YOU_REMOVE_STAINS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_REMOVING_STAINS[language]}
          </span>
          {TEXT_WHEN_YOU_CHOOSE_OUR_SPECIAL_STAIN_REMOVAL_ADD_ON[language]}
          {isMobile ? (
            <React.Fragment>
              {language === "TH" ? (
                <span>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>
                </span>
              ) : (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>
                </span>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {language === "EN" ? (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>
                </span>
              ) : (
                <div className="">
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Doyouwashcomforterscleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_WASH_COMFORTERS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_BUT_YOU_NEED_TO_SELECT_THE_CPMFORTER[language]}
          </span>
          {TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS[language]}
          <div className="-ml-1">
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </div>
        </div>
      )}
    </div>
  );
};
const AreThereanyadditionalcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_ARE_THERE_ANY_ADDITIONAL_COSTS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_YOU_NEED_TO_SELECT_THE_COMFORTER[language]}
          </span>
          {language === "EN" && (
            <div>
              {TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS[language]}
              <div>
                {" "}
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE_NO_MX}`}
                >
                  {TEXT_CREATE[language]}
                </span>{" "}
                {TEXT_AN_ORDER_NOW[language]}
              </div>
            </div>
          )}

          {language === "TH" && (
            <span>
              {TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS_ADDIC_TH[language]}
              <div>
                {TEXT_WE_WILL_WASH_ALL_LARGE_ITEMS_ADDIC_TH_2[language]}
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              </div>
            </span>
          )}

          {/* {isMobile ? (
              <React.Fragment>
                {language === "EN" ? (
                  <div className=" -ml-1">
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </div>
                ) : (
                  <span>
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {language === "EN" ? (
                  <div className=" -ml-1">
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </div>
                ) : (
                  <span>
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                )}
              </React.Fragment>
            )} */}
        </div>
      )}
    </div>
  );
};
const DoyouAcceptspecialrequestcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_ACCEPT_SPECIAL_REQUESTS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_ACCEPT_SPECIAL_REQUESTS[language]}
          </span>
          {TEXT_EX_IF_YOU_USE_HIGH_TEMP[language]}
          <span>
            {" "}
            <span
              onClick={() => navigate("/ContactUs")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_CONTACT_US[language]}
            </span>{" "}
            {TEXT_OR[language]}
            {isMobile && language === "TH" ? (
              <span className="">
                {" "}
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE_NO_MX}`}
                >
                  {TEXT_CREATE[language]}
                </span>{" "}
                {TEXT_AN_ORDER_NOW[language]}
              </span>
            ) : (
              <React.Fragment>
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW[language]}
              </React.Fragment>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
const Howdoyoucleancleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_HOW_DO_YOU_CLEAN_MY_CLOTHES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_CLEAN_ALL_FABRICS[language]}
          </span>
          {TEXT_KINDLY_MAKE_SURE[language]}
          <span>
            <span
              onClick={() => navigate("/ContactUs")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            {TEXT_OR[language]}
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Whochoosethecleaningcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHO_CHOOSE_THE_CLENING_METHOD[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_OUR_PROFESSINAL_LANDRY_SERVICE[language]}
          </span>

          <div>
            {" "}
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_CREATE[language]}
            </span>{" "}
            {TEXT_AN_ORDER_NOW[language]}
          </div>
        </div>
      )}
    </div>
  );
};
const Whocleansclothescleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHO_CLEANS_CLOTHES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {language === "TH" ? (
              <span>
                {" "}
                ทีมซักอบรีดของเราซักผ้าให้คุณอย่างพิถีพิถันที่ร้านซักผ้า
                {isMobile && <br />}มายลอนดรี้ของเราเอง
              </span>
            ) : (
              <span>
                {" "}
                With our professional laundry service, your laundry is cleaned
                by our dedicated laundry service team at our own facilities.
              </span>
            )}
            {/* {TEXT_CLEANED_BY_OUR_DEDICATED[language]} */}
          </span>

          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Wheredoyoucleansclothescleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHERE_DO_YOU_CLEAN_MY_CLOTHES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {language === "TH" ? (
              <span>
                {" "}
                ทีมซักอบรีดของเราซักผ้าให้คุณอย่างพิถีพิถันที่ร้านซักผ้า
                {isMobile && <br />}มายลอนดรี้ของเราเองทั้งในกรุงเทพ
              </span>
            ) : (
              <span>
                {" "}
                With our professional laundry service, your laundry will be
                cleaned at our own laundry facilities in Bangkok.
              </span>
            )}
            {/* {TEXT_CLEANED_AT_OUR_OWN_LAUNDRY[language]} */}
          </span>

          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {isMobile && language === "TH" ? (
              <div>{TEXT_AN_ORDER_NOW[language]}</div>
            ) : (
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
const Doyouofferdaycleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_OFFER_DRY_CLEANING[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_OFFER_DRY_CLEANING[language]}
          </span>
          {TEXT_BUT_WE_PLAN_TO_RESUME[language]}
          <span>
            {isMobile ? (
              <React.Fragment>
                {language === "TH" ? (
                  <div className="">
                    {" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </div>
                ) : (
                  <span>
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    <span>{TEXT_AN_ORDER_NOW[language]}</span>
                  </span>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              </React.Fragment>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
const Doyouofferhandwashcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_OFFER_A_HAND_WASHING[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">{TEXT_NO_WASH_HAND[language]}</span>
          {TEXT_BUT_WE_PREPARING[language]}
          {isMobile ? (
            <React.Fragment>
              <span>
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW[language]}
              </span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <div className="-ml-1">
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              ) : (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Aretheyanyitemsoffabriccleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_ARE_THERE_ANY_ITEMS_OF_FABRIC[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_DO_NOT_CLEAN_MATTRESS[language]}
          </span>
          {language === "TH" ? (
            <span>
              {" "}
              เราซักผ้าทั้งหมดทุกประเภทที่สามารถซักด้วยเครื่องซักผ้าและอบด้วยเครื่องอบผ้าได้
              หากมี<WhiteSpace>คำถามอื่นๆ</WhiteSpace>
            </span>
          ) : (
            <span>
              {" "}
              However, as a professional and reliable laundry service, we clean
              all fabrics which can be washed in a washing machine and dried in
              a tumble dryer. In case you have any questions, you can always
            </span>
          )}
          {/* {TEXT_HOWEVER_WE_CLEAN_ALL_FABRIC[language]} */}
          <span>
            <span
              onClick={() => navigate("/ContactUs")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            {TEXT_OR[language]}
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Doyoucleanweddingdresses = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_CLEAN_WEDDINGSREESES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_AT_THE_MOMENT[language]}
          </span>
          {TEXT_IN_CASE_YOU_HAVE_ANYQESTION[language]}
          {language === "EN" ? (
            <div className="-ml-1">
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {TEXT_OR[language]}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          ) : (
            <span>
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {TEXT_OR[language]}
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const Doyoucleanleathercleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_CLEAN_LEATHER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_CLEAN_LEATHER[language]}
          </span>
          {TEXT_WE_CLEAN_SHOES[language]}
          {isMobile ? (
            <React.Fragment>
              {language === "TH" ? (
                <div className=" -ml-1">
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              ) : (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              ) : (
                <div className=" -ml-1">
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Whathappensifamnothappycleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_HAPPENS_IF_AM_NOT_HAPPY[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {TEXT_IF_YOU_ARE_NOT_HAPPY[language]}
          <span>
            <span
              onClick={() => navigate("/ContactUs")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            {TEXT_AND_SEND_US[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Whathappensintheeventcleaning = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_HAPPENS_IN_THE_EVENT[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">{TEXT_WE_TRACK[language]}</span>
          {TEXT_IN_THE_UNLIKELY_EVENT[language]}
          <span>
            {" "}
            <span
              onClick={() => navigate("/TermsAndConditions")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_TERM_AND_CONDITION[language]}
            </span>
            {language === "EN" && <span className="">. </span>}{" "}
            {isMobile ? (
              // ? `${TEXT_MY_LAUNDRY_PUTS_CUSTOMER_MB[language]}`
              <React.Fragment>
                {language === "TH" ? (
                  <span>
                    {" "}
                    ของเรา
                    เพราะมายลอนดรี้ให้ความสำคัญกับการบริการลูกค้าเหนือสิ่งอื่นใดและมีความมุ่งมั่นที่จะสร้างความพึงพอใจให้ลูกค้าก่อนเสมอ
                    หากมี<WhiteSpace>คำถามอื่นๆ</WhiteSpace>
                  </span>
                ) : (
                  <span>
                    {" "}
                    My Laundry puts customer service above all else and is fully
                    committed to ensuring the satisfaction of our customers is
                    always put first. In case you have any questions, you can
                    always
                  </span>
                )}{" "}
              </React.Fragment>
            ) : (
              `${TEXT_MY_LAUNDRY_PUTS_CUSTOMER[language]}`
            )}
            {isMobile ? (
              <React.Fragment>
                {language === "TH" ? (
                  <span>
                    {" "}
                    <span
                      onClick={() => navigate("/ContactUs")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CONTACT_US[language]}
                    </span>{" "}
                    {TEXT_OR[language]}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                ) : (
                  <span className="">
                    {" "}
                    <span
                      onClick={() => navigate("/ContactUs")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CONTACT_US[language]}
                    </span>{" "}
                    {TEXT_OR[language]}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {language === "TH" ? (
                  <span className="">
                    {" "}
                    <span
                      onClick={() => navigate("/ContactUs")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CONTACT_US[language]}
                    </span>{" "}
                    {TEXT_OR[language]}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {" "}
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                ) : (
                  <span>
                    {" "}
                    <span
                      onClick={() => navigate("/ContactUs")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CONTACT_US[language]}
                    </span>{" "}
                    {TEXT_OR[language]}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                )}
              </React.Fragment>
            )}
          </span>
        </div>
      )}
    </div>
  );
};

const Cleaning = ({ classNameTitle, open, setOpen, superIndex }) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className="mb-8">
      <div className={`${STYLE_SIZE_FAQ(language)} ${STYLE_BOLD_BLUE} 4`}>
        {TEXT_LAUDRY_SERVICE_IN_DETAL[language]}
      </div>
      <DoINeedSortcleaning
        open={open}
        setOpen={setOpen}
        index={1}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <WillMyLaundrybewashedcleaning
        open={open}
        setOpen={setOpen}
        index={2}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <WhatTemperaturecleaning
        open={open}
        setOpen={setOpen}
        index={3}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Howdoyoudrycleaning
        open={open}
        setOpen={setOpen}
        index={4}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whattypesoflaundrycleaning
        open={open}
        setOpen={setOpen}
        index={5}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <IamAllergiccleaning
        open={open}
        setOpen={setOpen}
        index={6}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <WhattypesofDetergentscleaning
        open={open}
        setOpen={setOpen}
        index={7}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <CanIprovidecleaning
        open={open}
        setOpen={setOpen}
        index={8}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Canyouremovestainscleaning
        open={open}
        setOpen={setOpen}
        index={9}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyouwashcomforterscleaning
        open={open}
        setOpen={setOpen}
        index={10}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <AreThereanyadditionalcleaning
        open={open}
        setOpen={setOpen}
        index={11}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyoucleanweddingdresses
        open={open}
        setOpen={setOpen}
        index={12}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <DoyouAcceptspecialrequestcleaning
        open={open}
        setOpen={setOpen}
        index={13}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Howdoyoucleancleaning
        open={open}
        setOpen={setOpen}
        index={14}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whochoosethecleaningcleaning
        open={open}
        setOpen={setOpen}
        index={15}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whocleansclothescleaning
        open={open}
        setOpen={setOpen}
        index={16}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Wheredoyoucleansclothescleaning
        open={open}
        setOpen={setOpen}
        index={17}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyouofferdaycleaning
        open={open}
        setOpen={setOpen}
        index={18}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyouofferhandwashcleaning
        open={open}
        setOpen={setOpen}
        index={19}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Aretheyanyitemsoffabriccleaning
        open={open}
        setOpen={setOpen}
        index={20}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyoucleanleathercleaning
        open={open}
        setOpen={setOpen}
        index={21}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whathappensifamnothappycleaning
        open={open}
        setOpen={setOpen}
        index={22}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whathappensintheeventcleaning
        open={open}
        setOpen={setOpen}
        index={23}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
    </div>
  );
};

const Doyoucleanwhiteshoesshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_CLEAN_WHITE_SHOES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_WE_CLEAN_SHOES[language]}
          </span>
          {TEXT_WHEN_USE_OUR_PROFESSIONAL_SHOE[language]}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Whatbrandsandmodelsshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_BRANDS_AND_MODELS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          {isMobile ? (
            <React.Fragment>
              {/* en mobile */}
              {language === "EN" ? (
                <div>
                  {TEXT_THE_BRANDS_AND_MODELS[language]}
                  <div className="-ml-1">
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>
                    {TEXT_AN_ORDER_NOW[language]}
                  </div>
                </div>
              ) : (
                // thai mb
                <span>
                  {TEXT_THE_BRANDS_AND_MODELS_TH_MB_1[language]}
                  <div>
                    {language === "TH" && (
                      <span>
                        {" "}
                        บีทีเอส อดิดาส ครอส คอนเวิร์ส โอนิซึกะ ทิมเบอร์แลนด์
                        <WhiteSpace> เรดวิง </WhiteSpace>
                        <WhiteSpace> แสตนสมิทส์ </WhiteSpace> NMD Yeez ลาคอสต์
                        หรือ<WhiteSpace> นิวบาลานซ์ </WhiteSpace>{" "}
                        หากคุณเลือกบริการซักรองเท้าในกรุงเทพ
                        เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ
                        ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย
                        เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า
                      </span>
                    )}
                    {/* {TEXT_THE_BRANDS_AND_MODELS_TH_MB_2[language]} */}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX} `}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </div>
                </span>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <span>
                  {/* Thai desktop */}{" "}
                  {TEXT_THE_BRANDS_AND_MODELS_TH_1[language]}
                  <span>
                    {TEXT_THE_BRANDS_AND_MODELS_TH_2[language]}{" "}
                    <span
                      onClick={() => navigate("/OurServices")}
                      className={`${STYLE_LINK_BLUE_NO_MX}`}
                    >
                      {TEXT_CREATE[language]}
                    </span>{" "}
                    {TEXT_AN_ORDER_NOW[language]}
                  </span>
                </span>
              ) : (
                // en desktop
                <span>
                  {TEXT_THE_BRANDS_AND_MODELS[language]}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Doyoualsocleanshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_ALSO_CLEAN_THE_SOLE_OF_SHOES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_YES_WE_HAVE_DEVELOPED[language]}
          </span>
          {TEXT_THE_SHOES_CLEANING_METHOD[language]}
          <span>
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_CREATE[language]}
            </span>
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};
const Doyoucleantheinsolesshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_DO_YOU_CLEAN_THE_INSOLES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WE_CAN_CLEAN_BOTH[language]}
          </span>
          {TEXT_PLEASE_SELECT_THE_INTERIOR[language]}
          <span className="font-semibold">
            {TEXT_INTERIOR_CLEANING[language]}
          </span>
          {/* {TEXT_ADD_ON_IF_YOU_WOULD[language]} */}
          {language === "TH" ? (
            <span>
              {" "}
              เราพัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดรองเท้าด้านใน
              วิธีการทำความสะอาดของ{isMobile && <br />}
              สปารองเท้ามายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า
              หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นๆด้วย
              หากคุณเลือกบริการซักรองเท้าในกรุงเทพ
              เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ
              ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย
              เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า
            </span>
          ) : (
            <span>
              {" "}
              Add-On if you would specifically like us not only to clean the
              outside of your shoes but also to focus particularly on the inside
              of your shoes including the insole. We have developed different
              ways and technologies to clean the inside of shoes. The shoe
              cleaning methods we use include but are not limited to special
              washing, dry-cleaning, wet wiping and stain removal. When you use
              our professional shoe cleaning service in Bangkok or Pattaya, we
              additionally recommend choosing our Add-Ons Protection &
              Waterproofing and Shoe Perfume for ultimate shoe cleaning results.
            </span>
          )}
          {language === "EN" ? (
            <span>
              <span
                onClick={() => navigate("/OurServices")}
                className={`${STYLE_LINK_BLUE}`}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          ) : (
            <React.Fragment>
              {isMobile ? (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              ) : (
                <div className="-ml-1">
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Canleathershoesshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_LEATHER_SHOES_OR_LEATHER[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_LEATHER_SHOES_AND_SNEAKERS[language]}
          </span>
          {TEXT_AS_AN_EXPERIENCED[language]}
          {isMobile ? (
            <React.Fragment>
              {language === "TH" ? (
                <span>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              ) : (
                <span>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <div className="">
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              ) : (
                <span>
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`${STYLE_LINK_BLUE}`}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const Canvelourleathershoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_VELOUR_LEATHERS_SHOES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_NO_VELOUR_LEATHERS_SHOES[language]}
          </span>
          {TEXT_AS_PART_VELOUR_LEATHERS_SHOES[language]}
          {isMobile ? (
            <React.Fragment>
              <span>
                {" "}
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE_NO_MX}`}
                >
                  {TEXT_CREATE[language]}
                </span>{" "}
                {TEXT_AN_ORDER_NOW[language]}
              </span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span>
                {" "}
                <span
                  onClick={() => navigate("/OurServices")}
                  className={`${STYLE_LINK_BLUE_NO_MX}`}
                >
                  {TEXT_CREATE[language]}
                </span>{" "}
                {TEXT_AN_ORDER_NOW[language]}
              </span>
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};
const CanPlatformshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_CAN_PLATFORM_SHOES[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_IT_DEPENDS_ON_THE_MATERIAL[language]}
          </span>
          {/* {TEXT_IF_YOUR_PLATFORM[language]} */}
          {language === "TH" ? (
            <span>
              {" "}
              หากรองเท้าสตั๊ดของคุณทำจากหนัง เราไม่แนะนำให้ซักในเครื่องซักผ้า
              หากทำจากวัสดุทันสมัย อาจจะซักในเครื่องซักผ้าได้
              ในฐานะที่ร้านซักรองเท้า{isMobile && <br />}
              มายลอนดรี้เป็นมืออาชีพ
              เราพัฒนาวิธีและเทคโนโลยีที่แตกต่างเพื่อทำความสะอาดรองเท้าสตั๊ดทุกสีทุกประเภท
              โดยเฉพาะรองเท้าสตั๊ดสีขาว วิธีการทำความสะอาดของสปารองเท้า
              มายลอนดรี้ไม่เพียงแต่รวมการซักแห้งรองเท้า เช็ดรองเท้า
              หรือขจัดคราบด้วยยางลบ แต่ยังมีวิธีอื่นๆด้วย
              หากคุณเลือกบริการซักรองเท้าในกรุงเทพ
              เราขอแนะนำให้เลือกบริการเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำ
              ทำความสะอาดรองเท้าด้านใน และน้ำหอมสำหรับรองเท้าด้วย
              เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า
            </span>
          ) : (
            <span>
              {" "}
              If your platform shoes are made from leather, we do not recommend
              washing them in a washing machine. If your platform shoes are made
              from other modern fabrics, it might be possible to wash them in a
              washing machine. We have developed different ways and technologies
              to clean platform shoes all colours and types, especially white
              stack shoes. The shoe cleaning methods we use include but are not
              limited to dry-cleaning, wet wiping and stain removal. When you
              use our professional shoe cleaning service in Bangkok or Pattaya,
              we also recommend choosing our Add-Ons Protection & Waterproofing,
              Interior Shoe Cleansing and Shoe Perfume for ultimate shoe
              cleaning results.
            </span>
          )}

          <span>
            {" "}
            <span
              onClick={() => navigate("/OurServices")}
              className={`${STYLE_LINK_BLUE_NO_MX}`}
            >
              {TEXT_CREATE[language]}
            </span>{" "}
            {TEXT_AN_ORDER_NOW[language]}
          </span>
        </div>
      )}
    </div>
  );
};

const Whattypesshoes = ({
  index,
  open,
  setOpen,
  superIndex,
  classNameTitle,
}) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen =
    (open?.superIndex === superIndex && open?.index === index) || false;
  return (
    <div
      onClick={() => {
        if (isOpen) {
          setOpen({
            superIndex: -1,
            index: -1,
          });
        } else {
          setOpen({
            superIndex,
            index,
          });
        }
      }}
      className={`border-b border-b-laundry-border cursor-pointer  ${
        (location.pathname === "/FAQ" || location.pathname === "/FAQ/TH") &&
        "py-[4px]"
      }  `}
    >
      <div
        className={`flex justify-between items-center gap-2 py-[15px]  ${
          location.pathname === "/" || location.pathname === "/TH"
            ? " "
            : "h-[59px]"
        }  `}
      >
        <div className={classNameTitle}>
          {TEXT_WHAT_TYPES_AND_FABRICS[language]}
        </div>
        {isOpen ? (
          <div>
            <ICON_UP
              className={STYLE_ICON_HOME_FAQ}
              onClick={() => setOpen(-1)}
            />
          </div>
        ) : (
          <ICON_DOWN
            className={STYLE_ICON_HOME_FAQ}
            onClick={() => setOpen(index)}
          />
        )}
      </div>
      {isOpen && (
        <div className={`${STYLE_DES_FAQ(language)}`}>
          <span className="font-semibold">
            {TEXT_WITH_OUR_PREMIUM_SHOE[language]}
          </span>
          {TEXT_WE_ALSO_RECCOMEND_SHOE[language]}
          {isMobile ? (
            <span>
              {" "}
              <span
                onClick={() => navigate("/OurServices")}
                className={` linkblue  cursor-pointer`}
              >
                {TEXT_CREATE[language]}
              </span>{" "}
              {TEXT_AN_ORDER_NOW[language]}
            </span>
          ) : (
            <React.Fragment>
              {language === "TH" ? (
                <div className="">
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`linkblue  cursor-pointer`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              ) : (
                <span>
                  {" "}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={`linkblue  cursor-pointer`}
                  >
                    {TEXT_CREATE[language]}
                  </span>{" "}
                  {TEXT_AN_ORDER_NOW[language]}
                </span>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};

const Shoes = ({ classNameTitle, open, setOpen, superIndex }) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className="">
      <div className={`${STYLE_SIZE_FAQ(language)} ${STYLE_BOLD_BLUE} 5`}>
        {TEXT_SHOE_CLEANING_FAQS[language]}
      </div>
      <Whattypesshoes
        open={open}
        setOpen={setOpen}
        index={1}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyoucleanwhiteshoesshoes
        open={open}
        setOpen={setOpen}
        index={2}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Whatbrandsandmodelsshoes
        open={open}
        setOpen={setOpen}
        index={3}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyoualsocleanshoes
        open={open}
        setOpen={setOpen}
        index={4}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Doyoucleantheinsolesshoes
        open={open}
        setOpen={setOpen}
        index={5}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Canleathershoesshoes
        open={open}
        setOpen={setOpen}
        index={6}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <Canvelourleathershoes
        open={open}
        setOpen={setOpen}
        index={7}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
      <CanPlatformshoes
        open={open}
        setOpen={setOpen}
        index={8}
        classNameTitle={classNameTitle}
        superIndex={superIndex}
      />
    </div>
  );
};

const FaqList = () => {
  const { language } = React.useContext(ContextLanguage);
  const [open, setOpen] = React.useState({
    index: -1,
    superIndex: -1,
  });

  // React.useEffect(() => {
  //   if (open) {
  //     FunctionRepleteFont({ language });
  //   }
  // }, [open]);

  return (
    <div className={`${STYLE_PADDING_READING} mt-4 md:mt-13.5`}>
      <FirstOrder
        superIndex={0}
        open={open}
        setOpen={setOpen}
        classNameFont={`${STYLE_SIZE_FAQ(language)} 6`}
        classNameTitle={`${STYLE_BODY_1_SEMIBOLD_SM(
          language
        )} w-10/12 md:w-full cursor-pointer `}
      />
      <Pricing
        superIndex={1}
        open={open}
        setOpen={setOpen}
        classNameTitle={`${STYLE_BODY_1_SEMIBOLD_SM(
          language
        )}  w-10/12 md:w-full cursor-pointer`}
      />
      <Pickup
        superIndex={2}
        open={open}
        setOpen={setOpen}
        classNameTitle={`${STYLE_BODY_1_SEMIBOLD_SM(
          language
        )} w-10/12 md:w-full cursor-pointer`}
      />
      <General
        superIndex={3}
        open={open}
        setOpen={setOpen}
        classNameTitle={`${STYLE_BODY_1_SEMIBOLD_SM(
          language
        )} w-10/12 md:w-full cursor-pointer`}
      />
      <Cleaning
        superIndex={4}
        open={open}
        setOpen={setOpen}
        classNameTitle={`${STYLE_BODY_1_SEMIBOLD_SM(
          language
        )} w-10/12 md:w-full cursor-pointer`}
      />
      <Shoes
        superIndex={5}
        open={open}
        setOpen={setOpen}
        classNameTitle={`${STYLE_BODY_1_SEMIBOLD_SM(
          language
        )} w-10/12 md:w-full cursor-pointer`}
      />
    </div>
  );
};

export default FaqList;
